<ion-card class="ion-no-margin ion-no-padding picture-card">
  <ion-img [src]="displaySrc" class="picture" />
  @if (canRemove) {
    <div class="position-absolute top-50 start-50 translate-middle remove-image">
      <ion-icon color="primary" name="trash-outline" size="default" />
    </div>
  }
  @if (canFullscreen) {
    <div class="expand-image">
      <ion-icon color="primary" name="search-outline" size="default" />
    </div>
  }
</ion-card>
